import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  gql,
} from "@apollo/client";

console.log(process.env.REACT_APP_BACKEND_URL);
const client = new ApolloClient({
  uri:
    `${process.env.REACT_APP_BACKEND_URL}/graphql` ||
    "http://localhost:1337/graphql",
  cache: new InMemoryCache(),
});

export default client;
